var React = require('react');

function QuestionMarkInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.5","y":"1.5","width":"31","height":"31","rx":"8.5","stroke":"#0A9E50","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M16.5 19.1021V18.6774C16.5 17.302 17.3856 16.5738 18.2712 15.9872C19.1356 15.4208 20 14.6927 20 13.3577C20 11.4969 18.4398 10 16.5 10C14.5602 10 13 11.4969 13 13.3577","stroke":"#0A9E50","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M16.4901 23.9361H16.509","stroke":"#0A9E50","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

QuestionMarkInline.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = QuestionMarkInline;

QuestionMarkInline.default = QuestionMarkInline;
